import { SplitByCharacterWithPosition } from 'src/helper/splitByCharacter'
export const getRefTableDetail = (ref_table_detail: string) => {
    if ("train_detail_segment" === ref_table_detail ) {
        ref_table_detail = "train_segment_detail"
    }
    if ("train_detail_passes" === ref_table_detail){
        ref_table_detail = "train_passes_detail"
    }
    return SplitByCharacterWithPosition(ref_table_detail, "_detail", 0)
}